import React from "react";
import SharedChildTable from "../shared/SharedChildTable";

const ChildTable = ({
  childrenRecords,
  childrenColumns,
  selectedOutstandingDestinationRows,
  setSelectedOutstandingDestinationRows,
  popupOpen,
  setPopupOpen,
}) => {
  return (
    <SharedChildTable
      data={childrenRecords}
      childrenColumns={childrenColumns}
      selectedRows={selectedOutstandingDestinationRows}
      setSelectedRows={setSelectedOutstandingDestinationRows}
      popupOpen={popupOpen}
      setPopupOpen={setPopupOpen}
    />
  );
};

export default ChildTable;
